import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e821ec4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e821ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e821ec4')) {
      api.createRecord('4e821ec4', component.options)
    } else {
      api.reload('4e821ec4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e821ec4&scoped=true&", function () {
      api.rerender('4e821ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/webConfig/index.vue"
export default component.exports